import React, { useState, useEffect } from "react";
import { Image } from "react-bootstrap";
import { Collapse } from "antd";
import { MdHelpOutline } from "react-icons/md";
import { List, Divider } from "antd";
import { Row, Col } from "react-bootstrap";
import WorkoutPlaceholder from "../../styles/Assets/workout_placeholder.jpg";
import ExercisePlaceholder from "../../styles/Assets/exercise_placeholder_100_100.png";
import WorkoutSessionPlaceholder from "../../styles/Assets/workout_session_placeholder.jpeg";
import FormControl from "../../components/Common/FormControl";
import FormLabel from "../../components/Common/FormLabel";
import useCustomTranslation from "../../hooks/useCustomTranslation";
import Loader from "../../components/Common/Loader";
import { Progress } from "antd";
function CommonWorkoutPlan({ workoutPlan, isHistory }) {
  const { Panel } = Collapse;
  const { trans } = useCustomTranslation();
  const [workoutPlanStore, setWorkoutPlanStore] = useState(null);
  const formatProgress = (percent) => {
    if (percent === 100) {
      return <div className="workout-plan-progress-bar">{percent}%</div>;
    }
    return <div className="workout-plan-progress-bar">{percent}%</div>;
  };
  useEffect(() => {
    if (workoutPlan) {
      setWorkoutPlanStore(workoutPlan);
    }
  }, [workoutPlan]);
  return (
    <div>
      {!workoutPlanStore ? (
        <div>
          <Loader />
        </div>
      ) : (
        <div>
          {!isHistory && (
            <div>
              <Row>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <FormLabel label={trans("ClientWorkout.description")} />
                  <FormControl
                    className="rounded-3"
                    type="text"
                    name="description"
                    isDisabled={true}
                    value={workoutPlanStore?.description}
                    height={35}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <FormLabel
                    className="mt-1"
                    label={trans("ClientWorkout.introText")}
                  />
                  <FormControl
                    className="rounded-3"
                    type="text"
                    name="IntroText"
                    isDisabled={true}
                    value={
                      workoutPlanStore?.introText ||
                      trans("ClientWorkout.noIntroText")
                    }
                    height={35}
                  />
                </Col>
              </Row>
              <FormLabel
                className="mt-1"
                label={trans("ClientWorkout.plannedVolume")}
              />
              <Row className="planed-workout">
                <Col
                  className="sets-workout-planning"
                  xs={4}
                  sm={4}
                  md={4}
                  lg={4}
                >
                  <div>
                    <FormControl
                      className="rounded-3"
                      isDisabled={true}
                      value={workoutPlanStore?.plannedVolumeSets || 0}
                      suffix={trans("ClientWorkout.sets")}
                    />
                  </div>
                </Col>

                <Col
                  className="mx-1 planned-reps-allignment w-23"
                  xs={4}
                  sm={4}
                  md={4}
                  lg={4}
                >
                  <div>
                    <FormControl
                      className="rounded-3"
                      isDropdown={true}
                      isDisabled={true}
                      value={workoutPlanStore?.plannedVolumeReps || 0}
                      suffix={trans("ClientWorkout.reps")}
                    />
                  </div>
                </Col>
                <Col className=" mx-1 move-to-left" xs={4} sm={4} md={4} lg={4}>
                  <div className="workout-container ">
                    <div className="workout-time">
                      <FormControl
                        className="rounded-3"
                        isDisabled={true}
                        value={workoutPlan?.plannedVolumeSec || 0}
                        suffix={trans("ClientWorkout.secs")}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="mt-2">
                <FormLabel label={trans("ClientWorkout.coverPhoto")} />

                <div className="mx-3 mt-1 position-relative profile-image-container p-0">
                  {workoutPlanStore ? (
                    <Image
                      src={workoutPlanStore?.workoutPlanImage?.blobUrl?workoutPlanStore?.workoutPlanImage?.blobUrl:WorkoutPlaceholder}
                      alt="Profile Picture"
                      className="w-100 h-100 rounded-3"
                    />
                  ) : (
                    <Image
                      src={WorkoutPlaceholder}
                      alt="Default Profile"
                      className="w-100 h-100 rounded-3"
                    />
                  )}
                </div>
              </Row>
            </div>
          )}

          <Row>
            <FormLabel
              className=" mt-3 Label-text-workout-plan"
              label={trans("ClientWorkout.sessions")}
            />
            {!isHistory && (
              <Collapse accordion>
                {workoutPlan?.clientWorkoutPlanSessionResponses &&
                workoutPlan?.clientWorkoutPlanSessionResponses?.length > 0 ? (
                  workoutPlan?.clientWorkoutPlanSessionResponses?.map(
                    (session) => (
                      <Panel
                        header={
                          <div className="d-flex alignToRight">
                            <img
                              src={
                                session?.sessionPhotoImage?.blobUrl ||
                                WorkoutSessionPlaceholder
                              }
                              alt="Session"
                              className="excer-image"
                            />
                            <div className="Session-name-bold">
                              {session.sessionName}
                            </div>
                            <div>
                              <div className="client-completion-common-workout">
                                <Progress
                                  format={formatProgress}
                                  strokeColor={{
                                    "0%": "#383D8D",
                                    "100%": "#A42066",
                                  }}
                                  percent={
                                    session.sessionCompletion > 100
                                      ? 100
                                      : session.sessionCompletion
                                  }
                                  className="workout-plan client-progress-width"
                                />
                              </div>
                            </div>
                            <div className="sets-bold">
                              {session.totalSets} sets (
                              {
                                session.clientWorkoutPlanExerciseResponses
                                  ?.length
                              }
                              exercises)
                            </div>
                          </div>
                        }
                        key={session.clientId}
                      >
                        <Row className="session-inside w-auto">
                          <Row>
                            <Col xs={4} sm={4} md={4} lg={4}>
                              <div className="d-flex">
                                <div className="Label-text-workout-plan-session">
                                  {trans("ClientWorkout.equipment")}
                                </div>
                                <div className="questionmark-work">
                                  <MdHelpOutline />
                                </div>
                              </div>
                            </Col>

                            <Col xs={6} sm={6} md={6} lg={6}>
                              <div className="equipment-session">
                                {session.equipments}
                              </div>
                            </Col>
                          </Row>
                        </Row>
                        <Row>
                          <List
                            bordered
                            dataSource={session?.clientWorkoutPlanExerciseResponses
                              ?.slice()
                              .sort(
                                (a, b) =>
                                  (a.indexOrder || 0) - (b.indexOrder || 0)
                              )}
                            renderItem={(item, index) => (
                              <div className="p-2" key={index}>
                                <div className="d-flex">
                                  <div>
                                    <List.Item>
                                      <img
                                        src={
                                          item?.exerciseImage?.blobUrl
                                            ? item?.exerciseImage?.blobUrl
                                            : ExercisePlaceholder
                                        }
                                        alt={item.exercise}
                                        className="excer-image"
                                      />
                                    </List.Item>
                                  </div>
                                  <div>
                                    <Row className="allign-excer-name">
                                      <List.Item.Meta
                                        className="excer-name"
                                        title={item.exercise}
                                      />
                                    </Row>
                                    <Row>
                                      <div className="d-flex">
                                        <div className="exer-sets-width">
                                          <FormControl
                                            className="rounded-3"
                                            isDisabled={true}
                                            value={item.sets}
                                            suffix={trans("ClientWorkout.sets")}
                                          />
                                        </div>

                                        <div className="exer-sets-width allign-planned-exer">
                                          <FormControl
                                            className="rounded-3"
                                            isDisabled={true}
                                            isDropdown={true}
                                            value={item.sets}
                                            suffix={trans("ClientWorkout.reps")}
                                          />
                                        </div>
                                        <div className="exer-sets-width exersets-allign">
                                          <FormControl
                                            className="rounded-3"
                                            isDisabled={true}
                                            value={item.sec}
                                            suffix={trans("ClientWorkout.secs")}
                                          />
                                        </div>
                                      </div>
                                    </Row>
                                    <Row>
                                      <FormLabel
                                        className="mx-2 mt-1"
                                        label={"Notes"}
                                      />
                                      <div className=" mx-2 exer-notes-width">
                                        <FormControl
                                          className="rounded-3"
                                          isDisabled={true}
                                          value={item.note}
                                          Rows={4}
                                        />
                                      </div>
                                    </Row>
                                  </div>
                                </div>

                                {index <
                                  session?.clientWorkoutPlanExerciseResponses
                                    ?.length -
                                    1 && (
                                  <Divider className="divider-workout-plan" />
                                )}
                              </div>
                            )}
                          />
                        </Row>
                      </Panel>
                    )
                  )
                ) : (
                  <p> {trans("ClientWorkout.noSessions")}</p>
                )}
              </Collapse>
            )}

            {isHistory && (
              <Collapse accordion>
                {workoutPlan?.workoutSession && workoutPlan?.workoutSession ? (
                  <div>
                    <Panel
                      header={
                        <div className="d-flex alignToRight">
                          <img
                            src={
                              workoutPlan?.workoutSession.sessionPhotoUrl ||
                              WorkoutSessionPlaceholder
                            }
                            alt="Session"
                            className="excer-image"
                          />
                          <div className="Session-name-bold">
                            {workoutPlan?.workoutSession.sessionName}
                          </div>
                          <div>
                            <div className="client-completion-common-workout">
                              <Progress
                                format={formatProgress}
                                strokeColor={{
                                  "0%": "#383D8D",
                                  "100%": "#A42066",
                                }}
                                percent={
                                  workoutPlan?.workoutSession
                                    .sessionCompletion > 100
                                    ? 100
                                    : workoutPlan?.workoutSession
                                        .sessionCompletion
                                }
                                className="workout-plan client-progress-width"
                              />
                            </div>
                          </div>
                          <div className="sets-bold">
                            {workoutPlan?.workoutSession.totalSets} sets (
                            {
                              workoutPlan?.workoutSession
                                .clientWorkoutPlanExerciseResponses?.length
                            }
                            exercises)
                          </div>
                        </div>
                      }
                      key={workoutPlan.clientId}
                    >
                      <Row className="session-inside w-auto">
                        <Row>
                          <Col xs={4} sm={4} md={4} lg={4}>
                            <div className="d-flex">
                              <div className="Label-text-workout-plan-session">
                                {trans("ClientWorkout.equipment")}
                              </div>
                              <div className="questionmark-work">
                                <MdHelpOutline />
                              </div>
                            </div>
                          </Col>

                          <Col xs={6} sm={6} md={6} lg={6}>
                            <div className="equipment-session">
                              {workoutPlan?.workoutSession?.equipments}
                            </div>
                          </Col>
                        </Row>
                      </Row>
                    </Panel>
                    <Row>
                      <List
                        bordered
                        dataSource={workoutPlan?.workoutSession?.clientWorkoutPlanExerciseResponses
                          ?.slice()
                          .sort(
                            (a, b) => (a.indexOrder || 0) - (b.indexOrder || 0)
                          )}
                        renderItem={(item, index) => (
                          <div className="p-2" key={index}>
                            <div className="d-flex">
                              <div>
                                <List.Item>
                                  <img
                                    src={item?.exerciseImage?.blobUrl}
                                    alt={item.exercise}
                                    className="excer-image"
                                  />
                                </List.Item>
                              </div>
                              <div>
                                <Row className="allign-excer-name">
                                  <List.Item.Meta
                                    className="excer-name"
                                    title={item.exercise}
                                  />
                                </Row>
                                <Row>
                                  <div className="d-flex">
                                    <div className="exer-sets-width">
                                      <FormControl
                                        className="rounded-3"
                                        isDisabled={true}
                                        value={item.sets}
                                        suffix={trans("ClientWorkout.sets")}
                                      />
                                    </div>

                                    <div className="exer-sets-width allign-planned-exer">
                                      <FormControl
                                        className="rounded-3"
                                        isDisabled={true}
                                        isDropdown={true}
                                        value={item.reps}
                                        suffix={trans("ClientWorkout.reps")}
                                      />
                                    </div>
                                    <div className="exer-sets-width exersets-allign">
                                      <FormControl
                                        className="rounded-3"
                                        isDisabled={true}
                                        value={item.sec}
                                        suffix={trans("ClientWorkout.secs")}
                                      />
                                    </div>
                                  </div>
                                </Row>
                                <Row>
                                  <FormLabel
                                    className="mx-2 mt-1"
                                    label={"Notes"}
                                  />
                                  <div className=" mx-2 exer-notes-width">
                                    <FormControl
                                      className="rounded-3"
                                      isDisabled={true}
                                      value={item.note}
                                      Rows={4}
                                    />
                                  </div>
                                </Row>
                              </div>
                            </div>

                            {index <
                              workoutPlan?.workoutSession
                                ?.clientWorkoutPlanExerciseResponses?.length -
                                1 && (
                              <Divider className="divider-workout-plan" />
                            )}
                          </div>
                        )}
                      />
                    </Row>
                  </div>
                ) : (
                  <p> {trans("ClientWorkout.noSessions")}</p>
                )}
              </Collapse>
            )}
          </Row>
        </div>
      )}
    </div>
  );
}

export default CommonWorkoutPlan;
